import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Instagram, Facebook, Clock } from "lucide-react";
import { BRAND, SERVICES, SUBURBS } from "@/lib/site";

export default function Footer() {
  return (
    <footer className="bg-slate-900 text-slate-300" data-testid="site-footer">
      <div className="fg-container grid gap-12 py-16 md:grid-cols-12 md:gap-8">
        <div className="md:col-span-4">
          <div className="flex items-center gap-3">
            <div className="rounded-lg bg-white p-2">
              <img
                src={BRAND.logoUrl}
                alt="Flowgrid Plumbing"
                className="h-10 w-10 object-contain"
              />
            </div>
            <div>
              <div className="font-display text-2xl font-extrabold text-white">
                Flowgrid
              </div>
              <div className="text-[10px] font-bold uppercase tracking-[0.2em] text-slate-400">
                Plumbing
              </div>
            </div>
          </div>
          <p className="mt-5 max-w-sm text-sm leading-relaxed text-slate-400">
            24/7 licensed plumbers servicing all of Sydney.
            Fast response, honest pricing, work guaranteed.
          </p>
          <div className="mt-6 space-y-3 text-sm">
            <a
              href={BRAND.phoneTel}
              className="flex items-center gap-3 text-white transition-colors hover:text-blue-300"
              data-testid="footer-phone-link"
            >
              <Phone className="h-4 w-4 text-blue-400" />
              <span className="font-bold">{BRAND.phone}</span>
            </a>
            <a
              href={BRAND.emailHref}
              className="flex items-center gap-3 transition-colors hover:text-white"
              data-testid="footer-email-link"
            >
              <Mail className="h-4 w-4 text-blue-400" />
              {BRAND.email}
            </a>
            <div className="flex items-center gap-3">
              <MapPin className="h-4 w-4 text-blue-400" />
              Servicing all of Sydney
            </div>
            <div className="flex items-center gap-3">
              <Clock className="h-4 w-4 text-blue-400" />
              Open 24 hours, 7 days a week
            </div>
          </div>
        </div>

        <div className="md:col-span-3">
          <div className="text-xs font-bold uppercase tracking-[0.18em] text-slate-500">
            Services
          </div>
          <ul className="mt-4 space-y-2 text-sm">
            {SERVICES.map((s) => (
              <li key={s.slug}>
                <Link
                  to={`/services/${s.slug}`}
                  className="transition-colors hover:text-white"
                  data-testid={`footer-service-link-${s.slug}`}
                >
                  {s.title}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-3">
          <div className="text-xs font-bold uppercase tracking-[0.18em] text-slate-500">
            Service Areas
          </div>
          <ul className="mt-4 grid grid-cols-2 gap-2 text-sm">
            {SUBURBS.map((s) => (
              <li key={s.slug}>
                <Link
                  to={`/service-areas/${s.slug}`}
                  className="transition-colors hover:text-white"
                  data-testid={`footer-suburb-link-${s.slug}`}
                >
                  {s.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-2">
          <div className="text-xs font-bold uppercase tracking-[0.18em] text-slate-500">
            Company
          </div>
          <ul className="mt-4 space-y-2 text-sm">
            <li><Link to="/about" className="hover:text-white">About</Link></li>
            <li><Link to="/blog" className="hover:text-white">Blog</Link></li>
            <li><Link to="/contact" className="hover:text-white">Contact</Link></li>
            <li><Link to="/contact#quote" className="hover:text-white">Get a Quote</Link></li>
          </ul>
          <div className="mt-6 flex gap-2">
            <a
              href={BRAND.social.instagram}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Flowgrid Plumbing on Instagram"
              className="inline-flex h-9 w-9 items-center justify-center rounded-md border border-slate-700 transition-colors hover:border-blue-400 hover:text-blue-300"
              data-testid="footer-instagram"
            >
              <Instagram className="h-4 w-4" />
            </a>
            <a
              href={BRAND.social.facebook}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Flowgrid Plumbing on Facebook"
              className="inline-flex h-9 w-9 items-center justify-center rounded-md border border-slate-700 transition-colors hover:border-blue-400 hover:text-blue-300"
              data-testid="footer-facebook"
            >
              <Facebook className="h-4 w-4" />
            </a>
          </div>
        </div>
      </div>

      <div className="h-1 bg-blue-600" />
      <div className="border-t border-slate-800">
        <div className="fg-container flex flex-col items-start justify-between gap-3 py-6 text-xs text-slate-500 md:flex-row md:items-center">
          <div>
            © {new Date().getFullYear()} Flowgrid Plumbing. {BRAND.abn}
          </div>
          <div className="inline-flex items-center gap-2 rounded-md bg-yellow-400 px-3 py-1 font-bold uppercase tracking-[0.2em] text-slate-900">
            24/7 Emergency
          </div>
        </div>
      </div>
    </footer>
  );
}
